import { ref, readonly } from 'vue'

/**
 * Centralised navigation drawer state for the back-office shell.
 * Module-scoped singleton: the state is shared across every consumer
 * (mobile header, sidebar, overlay) without prop drilling.
 */
const isOpen = ref(false)

export const useSidebar = () => {
  const open = () => { isOpen.value = true }
  const close = () => { isOpen.value = false }
  const toggle = () => { isOpen.value = !isOpen.value }

  return { isOpen: readonly(isOpen), open, close, toggle }
}
